export type DotType = 'circle' | 'custom' | 'rectangular';
